import { Fragment } from 'react';
import cn from 'classnames';
import './Button.scss';

/**
 * @param {React.ButtonHTMLAttributes<HTMLButtonElement> & {
 *   children: React.ReactNode,
 *   variation: 'primary' | 'secondary' | 'tertiary' | 'quaternary';
 *   loading: boolean;
 *   url?: string;
 *   fullWidth?: boolean;
 * }} props
 */
const Button = ({
  children,
  variation = 'primary',
  fullWidth,
  loading,
  url,
  ...rest
}) => {
  const Element = url ? 'a' : 'button';

  return (
    <Element
      {...rest}
      href={url}
      disabled={rest.disabled || loading}
      className={cn(rest.className, {
        XButton: true,
        'XButton--loading': loading,
        'XButton--full-width': fullWidth,
        [`XButton--${variation}`]: variation,
      })}
    >
      <span className="XButton__Content">{children}</span>
    </Element>
  );
};

export default Button;
